import http from 'hub-http/clients/apiClient';

const getBaseUrl = useMigratedEndpoint => {
  return useMigratedEndpoint ? 'notification/preferences/v1/' : 'notification-station/user-preferences/v1/';
};

export const fetchPreferences = useMigratedEndpoint => {
  return http.get(`${getBaseUrl(useMigratedEndpoint)}preferences`);
};